// https://stackoverflow.com/a/60132060/10467064
export const __makeSureArrayContainsWholeUnion = <T>() => <U extends T[] | readonly T[]>(
	array: U & ([T] extends [U[number]] ? unknown : 'Invalid')
) => array;

// usage:
__makeSureArrayContainsWholeUnion<'a' | 'b'>()(['a','b'])
